// src/theme/foundations/semantic-layout.ts
import { defineSemanticTokens } from '@chakra-ui/react'

/** The maximum width of a page's content column, shared by every page family. */
export const semanticSizes = defineSemanticTokens.sizes({
  pageContent: { value: '1320px' },
})

/**
 * The layout rhythm of the application.
 *
 * The five tokens are ordered by how closely the things they separate belong
 * together: the tighter the relationship, the smaller the distance. A layout
 * picks the token for the relationship, not for the place, so the same kind of
 * distance is identical on the dashboard, on a subpage, and inside a form.
 *
 * They resolve onto the existing Chakra spacing scale; they name a role, they
 * do not introduce new values. Recipes reference them — feature code uses the
 * layout components, which carry the spacing already.
 */
export const semanticSpacing = defineSemanticTokens.spacing({
  /** Between a page's own blocks: page sections, dashboard widgets. */
  page: { value: '{spacing.12}' },
  /** The grid of a section: its columns, and the blocks stacked inside one column. */
  section: { value: '{spacing.10}' },
  /** Between the fields of a form, side by side and below one another. */
  fields: { value: '{spacing.8}' },
  /** Between content stacked inside one block: title and body, label and control. */
  stack: { value: '{spacing.2}' },
  /** Between elements sitting side by side on one line: buttons, a title and its badge. */
  inline: { value: '{spacing.3}' },
})
